import React from 'react';

const MailIcon = ({ backgroundColor, iconColor, ...iconProps }) => (
  <svg
    enableBackground="new 0 0 48 48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...{ height: 25, width: 25, ...iconProps }}
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="24"
        cy="24"
        fill={backgroundColor}
        fillRule="nonzero"
        r="24"
      />
      <g stroke={iconColor} strokeWidth="2.3" transform="translate(11 15)">
        <path d="m.61054 18.018751 8.367742-8.554242" />
        <path d="m24.609258 17.920143-8.142158-8.33702" />
        <path d="m.2354947.23735289 10.9212062 11.06664061c.8094898.8157457 2.2824776.8060831 3.074872.0074327l10.9137115-10.98500403" />
        <path d="m25.3157425 18.632326v-18.632326h-25.3157425v18.632326z" />
      </g>
    </g>
  </svg>
);

export default MailIcon;
